import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormGroupDirective } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { LookupService } from '../../services/lookup/lookup.service';
//import { ClaimantService } from '../../../services/claimant/claimant.service';
//import { Claimant } from '../../../models/claimant';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ToastrService } from 'ngx-toastr';
import { Locate } from '../../models/locate';



@Component({
  selector: 'app-lookup',
  templateUrl: './lookup.html',
  styleUrls: ['./lookup.css'],
  imports: [RouterModule, ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule, BsDatepickerModule],
})
export class Lookup {

  // Used to clear validation error states on Material form controls
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;

  loginInformation: FormGroup;
  authenticate: any;
  message: '';
  submitted = false;
  clicked = false;
  tempVar: number;
  showDivInClass: boolean = false;
  showDivNotInClass: boolean = false;


  constructor(
    private fb: FormBuilder,
    private loginService: LookupService,
    private _router: Router,
    private storage: LocalStorageService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,

  ) { }
  ngOnInit() {
    this.loginInformation = this.fb.group({
      streetNumber: ["", Validators.compose([Validators.required, Validators.maxLength(150), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      streetName: ["", Validators.compose([Validators.required, Validators.maxLength(150), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      zip: ["", Validators.compose([Validators.required, Validators.maxLength(5), Validators.minLength(5), Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      aptNumber: [''],
    })
  }

  get f() { return this.loginInformation.controls; }
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginInformation.invalid) {
      this.clicked = false;
      return;
    }

    this.clicked = true;
    const au = this.loginInformation.value;

    this.spinner.show();

    this.Login(au);
  }

  Login(au: Locate) {
    this.showDivInClass = false;
    this.showDivNotInClass = false;

    this.loginService.lookup(au).subscribe({
      next: (res) => {
        this.authenticate = res;

        if (this.authenticate != null) {
           this.showDivInClass = true;
         
        }
        else if (this.authenticate == null) {
           this.showDivNotInClass = true;

          
        }

        // cleanup
        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
        this.loginInformation.get('streetNumber').clearValidators();
        this.loginInformation.get('streetNumber').updateValueAndValidity();
        this.loginInformation.get('streetName').clearValidators();
        this.loginInformation.get('streetName').updateValueAndValidity();
        this.loginInformation.get('zip').clearValidators();
        this.loginInformation.get('zip').updateValueAndValidity();

      },

      error: (err) => {
        if (err.status === 404) {
          this.showDivNotInClass = true;
        } else {
          this.toastr.error('Something went wrong, Please Check Again', 'Error', {
            timeOut: 5000,
            positionClass: 'toast-bottom-full-width',
            progressBar: true
          });
        }

        this.spinner.hide();
        this.clicked = false;
        this.loginInformation.reset();
      }
    });
  }
}

